import React from 'react';
import { Box, Typography } from '@mui/material';

const CareerSectionTitle = ({ title, children }: { title: string; children?: React.ReactNode }) => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="flex-start" minHeight="32px" mb="10px">
      <Typography variant="h4" color="primary">
        {title}
      </Typography>

      {children}
    </Box>
  );
};

export default CareerSectionTitle;
